import { useState } from 'react';
import type { ReportExportType } from '@accounting/shared';
import { ApiError, downloadFile } from '../../lib/api';
import { CONSOLIDATED } from '../../stores/useCompanyStore';

export function ExportButtons({
  selection,
  type,
  params,
}: {
  selection: string;
  type: ReportExportType;
  params: Record<string, string>;
}) {
  const [busy, setBusy] = useState<'xlsx' | 'pdf' | null>(null);
  const [err, setErr] = useState<string | null>(null);

  const run = async (format: 'xlsx' | 'pdf') => {
    setBusy(format);
    setErr(null);
    try {
      const path =
        selection === CONSOLIDATED
          ? '/consolidated/reports/export'
          : `/companies/${selection}/reports/export`;
      await downloadFile(path, { type, format, ...params }, `${type}.${format}`);
    } catch (e) {
      setErr(e instanceof ApiError ? ((e.body as { error?: string } | null)?.error ?? 'Export failed') : 'Export failed');
    } finally {
      setBusy(null);
    }
  };

  return (
    <span style={{ display: 'inline-flex', gap: 8, alignItems: 'center' }}>
      <button
        className="btn-secondary"
        style={{ padding: '6px 12px', fontSize: 13 }}
        disabled={busy !== null}
        onClick={() => run('xlsx')}
      >
        {busy === 'xlsx' ? 'Exporting…' : 'Excel'}
      </button>
      <button
        className="btn-secondary"
        style={{ padding: '6px 12px', fontSize: 13 }}
        disabled={busy !== null}
        onClick={() => run('pdf')}
      >
        {busy === 'pdf' ? 'Exporting…' : 'PDF'}
      </button>
      {err && <span className="field-error" style={{ fontSize: 12 }}>{err}</span>}
    </span>
  );
}
